"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClientModel = void 0;
var _1 = require(".");
var order_line_client_model_1 = require("./order-line.client.model");
var OrderClientModel = /** @class */ (function () {
    function OrderClientModel(serverModel) {
        var _this = this;
        this.addressType = {
            from: 'return',
            to: 'delivery',
        };
        this.id = serverModel.id;
        this.dateCreated = serverModel.created_at;
        this.totalLineItems = serverModel.order_line.length;
        this.status = serverModel.status;
        this.addressFrom = '';
        this.addressTo = '';
        var addressTo = serverModel.addresses.find(function (address) { return address.pivot.address_type === _this.addressType.to; });
        if (addressTo) {
            this.addressTo = this.prepareAddress(addressTo);
        }
        var addressFrom = serverModel.addresses.find(function (address) { return address.pivot.address_type === _this.addressType.from; });
        if (addressFrom) {
            this.addressFrom = this.prepareAddress(addressFrom);
        }
        this.shipping_consignor = serverModel.shipping_consignor;
        this.shipping_invoice_currency = serverModel.shipping_invoice_currency;
        this.shipping_invoice_shipments = serverModel.shipping_invoice_shipments;
        this.shipping_invoice_total = serverModel.shipping_invoice_total;
        this.shipping_method = serverModel.shipping_method;
        this.lineItems = serverModel.order_line.map(function (item) { return new order_line_client_model_1.OrderLineClientModel(item); });
        this.orderRef = serverModel.order_ref;
        this.reprint = serverModel.reprint;
        this.xqc = serverModel.xqc;
        this.statusFormatted = this.status.name.replace(new RegExp('_', 'g'), ' ');
        this.stringifiedData = JSON.stringify(serverModel);
        this.order_submission_log = serverModel.order_submission_log
            ? new _1.OrderSubmissionClientModel(serverModel.order_submission_log)
            : null;
    }
    OrderClientModel.prototype.prepareAddress = function (address) {
        return "\n    " + (address.first_name || '') + " " + (address.last_name || '') + " " + (address.first_name || address.last_name ? ',' : '') + "\n    " + address.address1 + ", " + address.city + ", " + address.country;
    };
    return OrderClientModel;
}());
exports.OrderClientModel = OrderClientModel;
